import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddSpotComponent } from './components/add-spot/add-spot.component';
import { AssignMovesComponent } from './components/assign-moves/assign-moves.component';
import { MovesHistoryComponent } from './components/moves-history/moves-history.component';
import { MovesComponent } from './components/moves/moves.component';
import { TrailersComponent } from './components/trailers/trailers.component';
import { YardViewComponent } from './components/yard-view/yard-view.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PrivacyPolicyComponent } from './commons/privacy-policy/privacy-policy.component';
import { HomeComponent } from './home/home.component';
import { DownLoadsComponent } from './components/down-loads/down-loads.component';

import { InstructionsComponent } from './commons/instructions/instructions.component';
import { TermsOfServiceComponent } from './commons/terms-of-service/terms-of-service.component';
import { AboutUsComponent } from './commons/about-us/about-us.component';

// payment component
import { SubPricingComponent } from './payment/sub-pricing/sub-pricing.component';
import { SettingsComponent } from './payment/settings/settings.component';
import { SuccessComponent } from './payment/success/success.component';
import { CartViewComponent } from './payment/cart-view/cart-view.component';

import { RegisterComponent } from './auth/register/register.component';
import { UpdateEmailComponent } from './auth/update-email/update-email.component';
import { AccountDisabledComponent } from './auth/account-disabled/account-disabled.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { TokenVerificationComponent } from './auth/token-verification/token-verification.component';
import { UserManagementComponent } from './auth/user-management/user-management.component';
import { InstanceComponent } from './auth/instance/instance.component'
import { AuthGuardService } from './auth/auth-guard.service';
import { ContactComponent } from './commons/contact/contact.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  // app routes
  { path: 'yard-view', component: YardViewComponent, canActivate: [AuthGuardService], data: { instanceRequired: true } },
  { path: 'add-spot', component: AddSpotComponent, canActivate: [AuthGuardService], data: { roles: ['admin', 'clerk'], instanceRequired: true } },
  { path: 'assign-moves', component: AssignMovesComponent, canActivate: [AuthGuardService], data: { roles: ['admin', 'clerk'], instanceRequired: true } },
  { path: 'moves-history', component: MovesHistoryComponent, canActivate: [AuthGuardService], data: { instanceRequired: true } },
  { path: 'moves', component: MovesComponent, canActivate: [AuthGuardService], data: { instanceRequired: true } },
  { path: 'trailers', component: TrailersComponent, canActivate: [AuthGuardService], data: { instanceRequired: true } },
  { path: 'down-loads', component: DownLoadsComponent, canActivate: [AuthGuardService] },

  // finance components
  { path: 'success', component: SuccessComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true, roles: ['admin'] } },
  { path: 'cart-view', component: CartViewComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'pricing', component: SubPricingComponent },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true, roles: ['admin'] } },

  // auth components
  { path: 'register', component: RegisterComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
  { path: 'user-management', component: UserManagementComponent, canActivate: [AuthGuardService], data: { roles: ['admin'] } },
  { path: 'instance-management', component: InstanceComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'update-email', component: UpdateEmailComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'account-disabled', component: AccountDisabledComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'email-confirmation', component: EmailVerificationComponent, canActivate: [AuthGuardService] },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'update-password', component: UpdatePasswordComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'reset-password', component: ResetPasswordComponent, data: { loggedInAccessOnly: true } },
  { path: 'verification', component: TokenVerificationComponent },

  // footer components
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'about', component: AboutUsComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'instructions', component: InstructionsComponent },


  // 404 redirect
  { path: '**', component: ErrorPageComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
